import getServerSidePropsPage from 'root/src/client/util/getServerSidePropsPage';
import { RedesignCreatorsLeaderboardPage } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/RedesignCreatorsLeaderboardPage';
export const getServerSideProps = getServerSidePropsPage;
export default RedesignCreatorsLeaderboardPage;
